import _isString from "lodash/isString";
import _isFinite from "lodash/isFinite";
import _conformsTo from "lodash/conformsTo";
import { CARRIED_OFFER_STORAGE_KEY, CARRIED_OFFER_TTL_MS } from '../constants/promotion';
const STORED_OFFER_SHAPE = {
  code: _isString,
  savedAt: _isFinite
};
export const clearCarriedOffer = () => {
  try {
    localStorage.removeItem(CARRIED_OFFER_STORAGE_KEY);
  } catch {}
};
export const readCarriedOffer = (now = Date.now()) => {
  try {
    const raw = localStorage.getItem(CARRIED_OFFER_STORAGE_KEY);
    const stored = raw ? JSON.parse(raw) : undefined;
    if (!_conformsTo(stored, STORED_OFFER_SHAPE)) {
      return undefined;
    }
    const age = now - stored.savedAt;
    if (age < 0 || age >= CARRIED_OFFER_TTL_MS) {
      clearCarriedOffer();
      return undefined;
    }
    const code = stored.code.trim().toUpperCase();
    return code || undefined;
  } catch {
    return undefined;
  }
};
export const saveCarriedOffer = (code, now = Date.now()) => {
  const normalizedCode = code.trim().toUpperCase();
  if (!normalizedCode) {
    return;
  }
  const stored = JSON.stringify({
    code: normalizedCode,
    savedAt: now
  });
  try {
    localStorage.setItem(CARRIED_OFFER_STORAGE_KEY, stored);
  } catch {}
};